import { AnyAction } from 'redux'

export interface IAdminState {
  token: string | null
}

export const initialState: IAdminState = {
  token: null,
}

export const SET_ADMIN_TOKEN = 'SET_ADMIN_TOKEN'
export const CLEAR_ADMIN_TOKEN = 'CLEAR_ADMIN_TOKEN'

export function setAdminToken(token: string) {
  return {
    type: SET_ADMIN_TOKEN,
    token,
  }
}

export function clearAdminToken() {
  return {
    type: CLEAR_ADMIN_TOKEN,
  }
}

export function adminReducer(state = initialState, action: AnyAction) {
  switch (action.type) {
    case SET_ADMIN_TOKEN:
      return {
        token: action.token,
      }
    case CLEAR_ADMIN_TOKEN:
      return {
        token: null,
      }
    default:
      return state
  }
}
